export const SETUP_PROFILE = "@PROFILE.SETUP_PROFILE";
export const GET_PROFILE_INFO = "@PROFILE.GET_PROFILE_INFO";
export const SETUP_PROFILE_URL = "@PROFILE.SETUP_PROFILE_URL";
export const ON_LOGOUT = "@PROFILE.ON_LOGOUT";
export const MATCH = "@PROFILE.MATCH";
